import configureStore from "app/redux/Store";
let { store } = configureStore();

export const isFunction = (func) => {
  return typeof func === "function";
};

export const fetchPeriodStartDate = () => {
  const storeData = store.getState()?.userData?.periodMonthData;
  return storeData?.startDate || "";
};
